import { ApiService } from "./ApiService"

export class BankAccountService {

    static uri = '/bank-account';

    static get({ params }) {
        return ApiService.get(`${this.uri}`, {
            params,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static show({id}) {
        return ApiService.get(`${this.uri}/show/${id}`,{
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static create({data}) {
        return ApiService.post(`${this.uri}/create`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                'Content-Type': 'application/json'
            }
        });
    }

    static update({id, data}) {
        return ApiService.put(`${this.uri}/update/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            }
        });
    }

    static delete({id}) {
        return ApiService.delete(`${this.uri}/delete/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            }
        });
    }
}